import { FormValues } from './formValues.model';

const initialValue: FormValues = {
  email: '',
};

export default initialValue;
